import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

export interface DestinationAffinityParams {
  brand: string;
  /** Country code, e.g. AU */
  country: string;
  /** Custom schedule destination id, e.g. BALI */
  destination: string;
}

/**
 * `/api/customer-communication/v1/custom-schedules/destination-affinity`, for the given email
 */
export function makeDestinationAffinityURL(
  uri: `/${string}`,
  { brand, country, destination }: DestinationAffinityParams,
): URL {
  const url = makeCustomerCommunicationV1URL(`/custom-schedules/destination-affinity${uri}`);
  url.searchParams.set('brand', brand);
  url.searchParams.set('country', country);
  url.searchParams.set('destination', destination);
  return url;
}
